import { CommonModule } from '@angular/common';
import { Component, model } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';

import { SidebarComponent } from '@app/layout/sidebar/sidebar.component';

@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  imports: [MatSidenavModule, MatButtonModule, SidebarComponent, RouterOutlet, CommonModule, MatIcon],
})
export class DashboardLayoutComponent {
  showSidebar = model(false);
}
